import { DATE_SEARCH_OPTION_IDS } from 'constants/search'
import type GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'

export const GLOBAL_EXPERIENCES_SEARCH_INITIAL_STATE: GlobalSearchState = {
  ...GLOBAL_SEARCH_INITIAL_STATE,
  dateSearchOptionId: DATE_SEARCH_OPTION_IDS.ANYTIME,
}
